/* app/ui/rotator/rotator */

define(
    'app/ui/rotator/rotator',[
        'flickity',
        'pubsub'
    ],

    function (Flickity) {

        var $rotators;
        var $carousels;

        var selectors = {
            wrapper: '.js-rotator__wrapper',
            rotator: '.js-rotator',
            prev: '.js-rotator__prev',
            next: '.js-rotator__next',
            carouselItem: '.js-carousel-item'
        };

        var classes = {
            carouselItem: 'js-carousel-item',
            disableScroll: 'c-image-carousel__items--no-scroll'
        };

        var dataSelectors = {
            flickity: 'flickity-instance'
        };

        var module = {
            init: function ($elms) {
                $rotators = $elms;
                $carousels = $rotators.filter('[data-rotator-type="carousel"]');

                for (var i = 0; i < $rotators.length; i++) {
                    var $thisRotator = $rotators.eq(i);
                    var rotatorType = $thisRotator.attr('data-rotator-type') || 'content';
                    var settings = module._getRotatorSettings($thisRotator, rotatorType);
                    var enabled = true;

                    if (rotatorType === 'carousel') {
                        enabled = module._carouselRequired($thisRotator);
                    }

                    var thisFlick = new Flickity($rotators[i], settings);
                    $thisRotator.data(dataSelectors.flickity, thisFlick);

                    if (!enabled) {
                        $thisRotator.addClass(classes.disableScroll);
                    }
                }

                $.subscribe('/window/resize', module._carouselResize);
            },

            _carouselResize: function () {
                for (var i = 0; i < $rotators.length; i++) {
                    var $thisCarousel = $carousels.eq(i);
                    var enabled = module._carouselRequired($thisCarousel);
                    var scrollClassAction = enabled ? 'removeClass' : 'addClass';

                    $thisCarousel[scrollClassAction](classes.disableScroll);
                }
            },

            _carouselRequired: function ($rotator) {
                var windowWidth = $(window).width();
                var items = $rotator.find(selectors.carouselItem).length;
                var itemsToShow = 1;

                if (windowWidth >= 768) {
                    itemsToShow = 3;
                }
                if (windowWidth >= 1024) {
                    itemsToShow = 6;
                }

                return items > itemsToShow;
            },

            // Return the settings for the type of rotator that has been initialised
            // These can be edited, and new types can be added
            // Documentation for the options can be found here: https://flickity.metafizzy.co/
            _getRotatorSettings: function ($rotator, rotatorType) {
                var settings;
                var arrowShape = {
                    x0: 10,
                    x1: 60, y1: 50,
                    x2: 65, y2: 45,
                    x3: 20
                };

                switch (rotatorType) {

                    case 'home-hero':
                        settings = {
                            prevNextButtons: false,
                            pageDots: false,
                            autoPlay: 7000,
                            wrapAround: true,
                            lazyLoad: 2
                        };
                        break;

                    case 'image':
                        settings = {
                            prevNextButtons: false,
                            autoPlay: false,
                            wrapAround: false,
                            lazyLoad: true
                        };
                        break;

                    case 'gallery':
                        settings = {
                            arrowShape: arrowShape,
                            wrapAround: true,
                            lazyLoad: 1,
                            pageDots: false
                        };
                        break;

                    case 'carousel':
                        settings = {
                            arrowShape: arrowShape,
                            pageDots: false,
                            wrapAround: true,
                            lazyLoad: 6,
                            cellAlign: 'left'
                        };
                        break;

                    case 'tabbedproductcarousel':
                        settings = {
                            arrowShape: arrowShape,
                            pageDots: true,
                            wrapAround: false,
                            contain: true,
                            lazyLoad: 40,
                            cellAlign: 'left',
                            setGallerySize: false,
                        };

                        function CarouselArrows() {
                            var windowWidth = $(window).width();
                            var item = $rotator
                            var items = item.find(selectors.carouselItem).length;

                            if (windowWidth >= 1350) {

                                if (items == 3) {
                                    $(item).addClass("NoArrowsThree");
                                }

                                if (items == 2) {
                                    $(item).addClass("NoArrowsTwo");
                                }

                            } else if (windowWidth >= 1024) {
                                if (items == 3) {
                                    $(item).removeClass("NoArrowsThree");
                                }

                                if (items == 2) {
                                    $(item).addClass("NoArrowsTwo");
                                }
                            } else if (windowWidth >= 850) {
                                if (items == 3) {
                                    $(item).removeClass("NoArrowsThree");
                                }

                                if (items == 2) {
                                    $(item).removeClass("NoArrowsTwo");
                                }
                            }
                        };

                        $(document).ready(function () {
                            CarouselArrows();
                        });

                        $(window).resize(function () {
                            CarouselArrows();
                        });

                        break;

                    case 'projecthighlightrotator':
                        settings = {
                            prevNextButtons: false,
                            pageDots: true,
                            wrapAround: true,
                            contain: true,
                            lazyLoad: 12,
                            cellAlign: 'left',
                            setGallerySize: false,
                            autoPlay: 5000,
                            pauseAutoPlayOnHover: false,
                            fade: true,
                        };
                        break;

                    default:
                        settings = {
                            prevNextButtons: false,
                            autoPlay: false,
                            wrapAround: false,
                            lazyLoad: true
                        };
                }
                return settings;
            }
        };

        return {
            init: module.init
        };
    }
);
